import { render } from "./SearchStoryPage.vue?vue&type=template&id=66ccb000&scoped=true"
import script from "./SearchStoryPage.vue?vue&type=script&lang=js"
export * from "./SearchStoryPage.vue?vue&type=script&lang=js"

import "./SearchStoryPage.vue?vue&type=style&index=0&id=66ccb000&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ccb000"]])

export default __exports__